<script lang="ts">
  import "svelte-material-ui/bare.css"

  import { ApolloClient, InMemoryCache } from '@apollo/client';
  import { setClient } from "svelte-apollo";
  import { Router, Route } from "svelte-routing";

  import Header from "./common/Header.svelte"
  import HomePage from "./pages/HomePage.svelte"
  import LoginPage from "./pages/LoginPage.svelte"
  import SignUpPage from "./pages/SignUpPage.svelte"

  export let body: string;
  export let header: string;
  export let url: string = "";

  let authToken: string = '';

  const createApolloClient = (authToken) => {
   const cache = new InMemoryCache();

   const client = new ApolloClient({
      uri: "http://localhost:4000/",
      cache,
    });

    return client;
  }

  const client = createApolloClient('');
  setClient(client);
</script>

<div class="main-content">
  <Router url="{url}">
    <Header/>

    <div>
      <Route path="login" component="{LoginPage}" />
      <Route path="sign-up" component="{SignUpPage}" />
      <Route path="/"><HomePage/></Route>
    </div>
  </Router>
</div>


<h1 class="big-text">{header}</h1>
<p>{body}</p>

<style global>
  * {
    margin: 0;
  }

  body {
    padding: 0;
  }

  .main-content {
    text-align: center;
  }

  .paper-container {
    padding: 24px;
  }
</style>
